(()=>{const init=()=>{document.querySelectorAll('.menu-button').forEach(b=>b.addEventListener('click',()=>{const d=document.querySelector('.menu-drawer');if(d){d.classList.add('is-open');d.setAttribute('aria-hidden','false');b.setAttribute('aria-expanded','true');document.body.style.overflow='hidden'}}));const close=()=>{const d=document.querySelector('.menu-drawer');if(d){d.classList.remove('is-open');d.setAttribute('aria-hidden','true');document.body.style.overflow='';document.querySelector('.menu-button')?.setAttribute('aria-expanded','false')}};document.querySelectorAll('.menu-drawer__veil,.menu-drawer__top button').forEach(b=>b.addEventListener('click',close));document.addEventListener('keydown',e=>{if(e.key==='Escape')close()});const setMenuGroup=(group,open)=>{const button=group.querySelector('.menu-drawer__toggle'),submenu=group.querySelector('.menu-drawer__submenu');group.classList.toggle('is-open',open);button?.setAttribute('aria-expanded',String(open));if(button){const label=group.querySelector('.menu-drawer__label')?.textContent.trim()||'';button.setAttribute('aria-label',(open?'Zwiń':'Rozwiń')+' podmenu: '+label)}if(submenu)submenu.hidden=!open};const bindMenuGroups=root=>{root.querySelectorAll('.menu-drawer__toggle').forEach(button=>{if(button.dataset.pmwMenuToggleBound==='true')return;button.dataset.pmwMenuToggleBound='true';button.addEventListener('click',event=>{event.preventDefault();event.stopPropagation();const group=button.closest('.menu-drawer__group'),open=!group.classList.contains('is-open');if(open)group.closest('.menu-drawer')?.querySelectorAll('.menu-drawer__group.is-open').forEach(other=>setMenuGroup(other,false));setMenuGroup(group,open)})})};bindMenuGroups(document);document.addEventListener('shopify:section:load',event=>bindMenuGroups(event.target));const bindSpaCatalogs=root=>{root.querySelectorAll('[data-spa-catalog]').forEach(catalog=>{if(catalog.dataset.pmwCatalogReady==='true')return;catalog.dataset.pmwCatalogReady='true';const rail=catalog.querySelector('.spa-category-grid'),tabs=[...catalog.querySelectorAll('.spa-category-grid [role="tab"]')],panels=[...catalog.querySelectorAll('[data-spa-treatment-panel]')],activate=tab=>{const key=tab.dataset.spaCategory;tabs.forEach(item=>{const active=item===tab;item.classList.toggle('is-active',active);item.setAttribute('aria-selected',String(active));item.tabIndex=active?0:-1});panels.forEach(panel=>{const active=panel.dataset.spaTreatmentPanel===key;panel.hidden=!active;panel.setAttribute('aria-hidden',String(!active))})};tabs.forEach(tab=>tab.addEventListener('click',()=>activate(tab)));const initial=tabs.find(tab=>tab.classList.contains('is-active'))||tabs[0];if(initial)activate(initial);catalog.querySelector('.spa-category-carousel__arrow--previous')?.addEventListener('click',()=>rail?.scrollBy({left:-rail.clientWidth*.72,behavior:'smooth'}));catalog.querySelector('.spa-category-carousel__arrow--next')?.addEventListener('click',()=>rail?.scrollBy({left:rail.clientWidth*.72,behavior:'smooth'}))})};bindSpaCatalogs(document);document.addEventListener('shopify:section:load',event=>bindSpaCatalogs(event.target));const bindPackageCatalogs=root=>{root.querySelectorAll('[data-packages-catalog]').forEach(catalog=>{if(catalog.dataset.pmwPackageFiltersReady==='true')return;catalog.dataset.pmwPackageFiltersReady='true';const filters=[...catalog.querySelectorAll('[data-package-filter]')],cards=[...catalog.querySelectorAll('[data-package-card]')],activate=filter=>{const key=filter.dataset.packageFilter;filters.forEach(button=>{const active=button===filter;button.classList.toggle('is-active',active);button.setAttribute('aria-pressed',String(active))});cards.forEach(card=>{const categories=(card.dataset.packageCategories||'').split(/\s+/);const visible=key==='all'||categories.includes(key);card.hidden=!visible;card.classList.toggle('is-filtered-out',!visible);card.setAttribute('aria-hidden',String(!visible))})};filters.forEach(filter=>filter.addEventListener('click',()=>activate(filter)));const initial=filters.find(filter=>filter.classList.contains('is-active'))||filters[0];if(initial)activate(initial)})};bindPackageCatalogs(document);document.addEventListener('shopify:section:load',event=>bindPackageCatalogs(event.target));document.addEventListener('shopify:block:select',event=>{const selected=event.target.closest?.('[data-spa-category],[data-spa-treatment-category]');if(!selected)return;const catalog=selected.closest('[data-spa-catalog]'),key=selected.dataset.spaCategory||selected.dataset.spaTreatmentCategory;[...catalog.querySelectorAll('.spa-category-grid [role="tab"]')].find(tab=>tab.dataset.spaCategory===key)?.click()});const setSpaTab=item=>{const spa=item.closest('.spa');if(!spa)return;spa.querySelectorAll('.accordion__item').forEach(other=>{const button=other.querySelector('button'),active=other===item;other.classList.toggle('is-open',active);button?.setAttribute('aria-expanded',String(active));const icon=button?.querySelector('[aria-hidden]');if(icon)icon.textContent=active?'−':'+'});const index=item.dataset.spaIndex;spa.querySelectorAll('.spa__tab-image').forEach(image=>{const active=image.dataset.spaImageIndex===index;image.classList.toggle('is-active',active);image.setAttribute('aria-hidden',String(!active))});spa.querySelectorAll('.spa__tab-overlay').forEach(overlay=>overlay.classList.toggle('is-active',overlay.dataset.pmwOverlayIndex===index))};const bindAccordions=root=>{root.querySelectorAll('.accordion__item button').forEach(b=>{if(b.dataset.pmwAccordionBound==='true')return;b.dataset.pmwAccordionBound='true';b.addEventListener('click',()=>{const item=b.closest('.accordion__item');if(item.closest('.spa')){setSpaTab(item);return}const open=item.classList.toggle('is-open');b.setAttribute('aria-expanded',String(open));b.querySelector('[aria-hidden]')&&(b.querySelector('[aria-hidden]').textContent=open?'−':'+')})})};bindAccordions(document);document.addEventListener('shopify:section:load',e=>bindAccordions(e.target));document.addEventListener('shopify:block:select',e=>{const item=e.target.closest?.('.spa .accordion__item');if(item)setSpaTab(item)});document.querySelectorAll('.rooms-carousel').forEach(c=>{const rail=c.querySelector('.horizontal-cards');c.querySelector('.rooms-carousel__button--previous')?.addEventListener('click',()=>rail.scrollBy({left:-rail.clientWidth*.72,behavior:'smooth'}));c.querySelector('.rooms-carousel__button--next')?.addEventListener('click',()=>rail.scrollBy({left:rail.clientWidth*.72,behavior:'smooth'}))});document.querySelectorAll('[data-heritage-counter]').forEach(el=>{if(el.dataset.counterReady==='true')return;el.dataset.counterReady='true';const raw=(el.dataset.heritageCounter||el.textContent||'').trim(),match=raw.match(/-?\d+(?:[.,]\d+)?/);if(!match)return;const numberText=match[0],target=Number(numberText.replace(',','.')),prefix=raw.slice(0,match.index),suffix=raw.slice((match.index||0)+numberText.length),decimals=(numberText.split(/[.,]/)[1]||'').length,format=value=>prefix+(decimals?value.toFixed(decimals).replace('.',','):Math.round(value))+suffix,reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;new IntersectionObserver((entries,observer)=>{if(!entries[0].isIntersecting)return;if(reduce){el.textContent=raw;observer.disconnect();return}const started=performance.now(),duration=1150;el.textContent=format(0);const tick=now=>{const progress=Math.min((now-started)/duration,1),eased=1-Math.pow(1-progress,3);el.textContent=progress===1?raw:format(target*eased);if(progress<1)requestAnimationFrame(tick)};requestAnimationFrame(tick);observer.disconnect()},{threshold:.45}).observe(el)});const reviews=[...document.querySelectorAll('.reviews blockquote')],dots=[...document.querySelectorAll('.review-controls button')];dots.forEach((b,i)=>b.addEventListener('click',()=>{reviews.forEach((r,j)=>r.hidden=i!==j);dots.forEach((d,j)=>{d.classList.toggle('is-active',i===j);d.setAttribute('aria-pressed',String(i===j))})}));document.querySelectorAll('a[href^="#"]').forEach(a=>a.addEventListener('click',e=>{const t=document.querySelector(a.getAttribute('href'));if(t){e.preventDefault();t.scrollIntoView({behavior:'smooth'})}}))};document.readyState==='loading'?document.addEventListener('DOMContentLoaded',init):init()})();

;(()=>{const ready=()=>{const gate=document.querySelector('.vineyard-age-gate');if(gate){try{if(sessionStorage.getItem('pmw-age-ok')==='1')gate.hidden=true}catch(e){}gate.querySelector('button')?.addEventListener('click',()=>{gate.hidden=true;try{sessionStorage.setItem('pmw-age-ok','1')}catch(e){}})}document.querySelectorAll('.history-chronicle').forEach(root=>{const buttons=[...root.querySelectorAll('.history-chronicle__nav button')],chapters=[...root.querySelectorAll('[data-history-chapter]')];buttons.forEach((button,index)=>button.addEventListener('click',()=>{buttons.forEach((item,i)=>{item.classList.toggle('is-active',i===index);i===index?item.setAttribute('aria-current','step'):item.removeAttribute('aria-current')});chapters[index]?.scrollIntoView({behavior:'smooth',block:'center'})}))});document.querySelectorAll('.room-product').forEach(root=>{const stage=root.querySelector('.room-product__stage'),counter=root.querySelector('.room-product__counter'),buttons=[...root.querySelectorAll('.room-product__thumbs button')];buttons.forEach((button,index)=>button.addEventListener('click',()=>{const image=button.querySelector('img');if(!image||!stage)return;stage.querySelector('img')?.setAttribute('src',image.currentSrc||image.src);stage.querySelector('img')?.setAttribute('alt',button.getAttribute('aria-label')||'Zdjęcie pokoju');counter&&(counter.textContent=String(index+1).padStart(2,'0')+' / '+String(buttons.length).padStart(2,'0'));buttons.forEach((item,i)=>item.classList.toggle('is-active',i===index))}))});const bindRoomDescriptions=root=>{root.querySelectorAll('[data-room-description]').forEach(description=>{if(description.dataset.pmwDescriptionReady==='true')return;description.dataset.pmwDescriptionReady='true';const shell=description.closest('.room-product__lead-shell'),toggle=shell?.querySelector('[data-room-description-toggle]');if(!toggle)return;requestAnimationFrame(()=>{const lineHeight=parseFloat(getComputedStyle(description).lineHeight)||28,needsToggle=description.scrollHeight>lineHeight*6+4;if(!needsToggle){toggle.hidden=true;return}description.classList.add('is-collapsible');toggle.hidden=false;toggle.addEventListener('click',()=>{const expanded=description.classList.toggle('is-expanded');toggle.setAttribute('aria-expanded',String(expanded));toggle.querySelector('span:first-child').textContent=expanded?'Zwiń opis':'Rozwiń więcej'})})})};bindRoomDescriptions(document);document.addEventListener('shopify:section:load',event=>bindRoomDescriptions(event.target));const closeLightbox=()=>{document.querySelector('.pmw-lightbox')?.remove();document.body.style.overflow=''};document.querySelectorAll('.gallery-media-card,.room-gallery button').forEach(button=>button.addEventListener('click',()=>{const media=button.querySelector('img,video');if(!media)return;const box=document.createElement('div');box.className='pmw-lightbox';box.setAttribute('role','dialog');box.setAttribute('aria-modal','true');const clone=media.cloneNode(true);clone.removeAttribute('loading');clone.controls=clone.tagName==='VIDEO';box.append(clone);const close=document.createElement('button');close.type='button';close.className='pmw-lightbox__close';close.setAttribute('aria-label','Zamknij');close.textContent='×';close.addEventListener('click',closeLightbox);box.append(close);box.addEventListener('click',event=>{if(event.target===box)closeLightbox()});document.body.append(box);document.body.style.overflow='hidden'}));document.addEventListener('keydown',event=>{if(event.key==='Escape'){closeLightbox();document.body.style.overflow=''}});document.querySelectorAll('.gallery-show-more').forEach(button=>button.addEventListener('click',()=>{document.querySelector('.gallery-collage')?.classList.toggle('is-expanded');button.hidden=true}));document.querySelectorAll('.wedding-faq__list article button').forEach(button=>button.addEventListener('click',()=>{const article=button.closest('article'),panel=button.nextElementSibling,open=!article.classList.contains('is-open');article.classList.toggle('is-open',open);button.setAttribute('aria-expanded',String(open));button.querySelector('[aria-hidden]')&&(button.querySelector('[aria-hidden]').textContent=open?'−':'+');panel&&(panel.hidden=!open)}));document.querySelectorAll('.menu-drawer a').forEach(link=>link.addEventListener('click',()=>{const drawer=link.closest('.menu-drawer');drawer?.classList.remove('is-open');drawer?.setAttribute('aria-hidden','true');document.body.style.overflow=''}))};document.readyState==='loading'?document.addEventListener('DOMContentLoaded',ready):ready()})();
/* PMW business interactions 2026-09 */
(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const initBusinessCounters = (root = document) => {
    root.querySelectorAll('[data-business-counter]').forEach((counter) => {
      if (counter.dataset.businessCounterReady === 'true') return;
      counter.dataset.businessCounterReady = 'true';
      const raw = (counter.dataset.businessCounter || counter.textContent || '').trim();
      const target = Number(raw.replace(',', '.'));
      if (!Number.isFinite(target)) return;
      const decimals = (raw.split(/[.,]/)[1] || '').length;
      const format = (value) => decimals ? value.toFixed(decimals).replace('.', ',') : String(Math.round(value));
      if (reducedMotion.matches || !('IntersectionObserver' in window)) {
        counter.textContent = raw;
        return;
      }
      const observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        const start = performance.now();
        const duration = 1400;
        counter.textContent = format(0);
        const tick = (now) => {
          const progress = Math.min((now - start) / duration, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          counter.textContent = progress === 1 ? raw : format(target * eased);
          if (progress < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      }, { threshold: .35 });
      observer.observe(counter);
    });
  };

  const initBusinessTimelines = (root = document) => {
    root.querySelectorAll('[data-business-timeline]').forEach((timeline) => {
      if (timeline.dataset.businessTimelineReady === 'true') return;
      timeline.dataset.businessTimelineReady = 'true';
      const items = [...timeline.querySelectorAll('[data-business-timeline-item]')];
      const media = [...timeline.querySelectorAll('[data-business-parallax]')];

      if (!reducedMotion.matches && 'IntersectionObserver' in window) {
        items.forEach((item) => item.classList.add('business-timeline-reveal--pending'));
        const reveal = new IntersectionObserver((entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            requestAnimationFrame(() => entry.target.classList.add('is-visible'));
            observer.unobserve(entry.target);
          });
        }, { threshold: .18, rootMargin: '0px 0px -6% 0px' });
        items.forEach((item) => reveal.observe(item));
      }

      if (reducedMotion.matches || !media.length) return;
      let ticking = false;
      const updateParallax = () => {
        ticking = false;
        const viewport = window.innerHeight || document.documentElement.clientHeight;
        media.forEach((frame) => {
          const rect = frame.getBoundingClientRect();
          if (rect.bottom < 0 || rect.top > viewport) return;
          const progress = ((rect.top + rect.height / 2) - viewport / 2) / (viewport + rect.height);
          const range = window.matchMedia('(max-width: 760px)').matches ? 9 : 34;
        const offset = Math.max(-range, Math.min(range, progress * -range * 2));
          frame.style.setProperty('--pmw-parallax-y', `${offset}px`);
        });
      };
      const requestUpdate = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(updateParallax);
      };
      updateParallax();
      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate, { passive: true });
    });
  };

  const initBusiness = (root = document) => {
    initBusinessCounters(root);
    initBusinessTimelines(root);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initBusiness());
  else initBusiness();
  document.addEventListener('shopify:section:load', (event) => initBusiness(event.target));
})();
/* PMW business venue map interactions 2026-09 */
(() => {
  const activateMap = (map, index, focus = false) => {
    const tabs = [...map.querySelectorAll('[data-business-map-tab]')];
    const panels = [...map.querySelectorAll('[data-business-map-panel]')];
    tabs.forEach((tab) => {
      const active = tab.dataset.businessMapTab === String(index);
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
      if (active && focus) tab.focus();
    });
    panels.forEach((panel) => {
      const active = panel.dataset.businessMapPanel === String(index);
      panel.hidden = !active;
      panel.setAttribute('aria-hidden', String(!active));
    });
  };

  const initVenueMaps = (root = document) => {
    root.querySelectorAll('[data-business-venue-map]').forEach((map) => {
      if (map.dataset.businessVenueMapReady === 'true') return;
      map.dataset.businessVenueMapReady = 'true';
      const tabs = [...map.querySelectorAll('[data-business-map-tab]')];
      tabs.forEach((tab, position) => {
        tab.addEventListener('click', () => activateMap(map, tab.dataset.businessMapTab));
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let next = position;
          if (event.key === 'ArrowRight') next = (position + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (position - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          activateMap(map, tabs[next].dataset.businessMapTab, true);
        });
      });
      if (tabs[0]) activateMap(map, tabs[0].dataset.businessMapTab);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initVenueMaps());
  else initVenueMaps();
  document.addEventListener('shopify:section:load', (event) => initVenueMaps(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const panel = event.target.closest?.('[data-business-map-panel]');
    const map = panel?.closest('[data-business-venue-map]');
    if (panel && map) activateMap(map, panel.dataset.businessMapPanel);
  });
})();
/* PMW business venue cards filter 2026-09 */
(() => {
  const plural = (count) => count === 1 ? '1 sala' : ((count % 10 >= 2 && count % 10 <= 4 && (count % 100 < 12 || count % 100 > 14)) ? `${count} sale` : `${count} sal`);
  const filterVenueCards = (map, key) => {
    const cards = [...map.querySelectorAll('[data-business-venue-card]')];
    let visible = 0;
    cards.forEach((card) => {
      const show = key === 'all' || card.dataset.businessVenueCard === key;
      card.hidden = !show;
      card.setAttribute('aria-hidden', String(!show));
      if (show) visible += 1;
    });
    const count = map.querySelector('[data-business-venue-count]');
    if (count) count.textContent = plural(visible);
    const empty = map.querySelector('[data-business-venue-empty]');
    if (empty) empty.hidden = visible !== 0;
  };
  const initVenueCardFilters = (root = document) => {
    root.querySelectorAll('[data-business-venue-map]').forEach((map) => {
      if (map.dataset.businessVenueCardsReady === 'true') return;
      map.dataset.businessVenueCardsReady = 'true';
      const tabs = [...map.querySelectorAll('[data-business-map-tab]')];
      tabs.forEach((tab) => tab.addEventListener('click', () => filterVenueCards(map, tab.dataset.businessMapTab)));
      filterVenueCards(map, tabs.find((tab) => tab.classList.contains('is-active'))?.dataset.businessMapTab || 'all');
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initVenueCardFilters());
  else initVenueCardFilters();
  document.addEventListener('shopify:section:load', (event) => initVenueCardFilters(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const card = event.target.closest?.('[data-business-venue-card]');
    const map = card?.closest('[data-business-venue-map]');
    if (!card || !map) return;
    map.querySelector(`[data-business-map-tab="${card.dataset.businessVenueCard}"]`)?.click();
    card.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
})();
/* PMW homepage mobile offers carousel 2026-09 */
(() => {
  const initHomeOfferCarousels = (root = document) => {
    root.querySelectorAll('[data-home-offer-carousel]').forEach((carousel) => {
      if (carousel.dataset.homeOfferCarouselReady === 'true') return;
      carousel.dataset.homeOfferCarouselReady = 'true';
      const track = carousel.querySelector('[data-home-offer-track]');
      const cards = [...carousel.querySelectorAll('[data-home-offer-card]')];
      const dots = [...carousel.querySelectorAll('[data-home-offer-dot]')];
      if (!track || cards.length < 2) return;
      let activeIndex = 0;
      let frame = 0;
      const setActive = (index) => {
        activeIndex = Math.max(0, Math.min(index, cards.length - 1));
        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === activeIndex;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-pressed', String(active));
        });
      };
      const goTo = (index) => {
        const next = Math.max(0, Math.min(index, cards.length - 1));
        cards[next].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        setActive(next);
      };
      carousel.querySelector('[data-home-offer-prev]')?.addEventListener('click', () => goTo(activeIndex - 1));
      carousel.querySelector('[data-home-offer-next]')?.addEventListener('click', () => goTo(activeIndex + 1));
      dots.forEach((dot, index) => dot.addEventListener('click', () => goTo(index)));
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          const trackLeft = track.getBoundingClientRect().left;
          const closest = cards.reduce((best, card, index) => {
            const distance = Math.abs(card.getBoundingClientRect().left - trackLeft);
            return distance < best.distance ? { index, distance } : best;
          }, { index: 0, distance: Infinity });
          setActive(closest.index);
        });
      }, { passive: true });
      setActive(0);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initHomeOfferCarousels());
  else initHomeOfferCarousels();
  document.addEventListener('shopify:section:load', (event) => initHomeOfferCarousels(event.target));
})();
/* PMW homepage mobile accordions and unified carousels 2026-09 */
(() => {
  const activateDots = (dots, index) => dots.forEach((dot, dotIndex) => {
    const active = dotIndex === index;
    dot.classList.toggle('is-active', active);
    dot.setAttribute('aria-pressed', String(active));
  });

  const bindSnapCarousel = (carousel, trackSelector, cardSelector, dotSelector, prevSelector, nextSelector, stopExisting = false) => {
    if (!carousel || carousel.dataset.pmwUnifiedCarousel === 'true') return;
    carousel.dataset.pmwUnifiedCarousel = 'true';
    const track = carousel.querySelector(trackSelector);
    const cards = [...carousel.querySelectorAll(cardSelector)];
    const dots = [...carousel.querySelectorAll(dotSelector)];
    const prev = carousel.querySelector(prevSelector);
    const next = carousel.querySelector(nextSelector);
    if (!track || cards.length < 2) return;
    let active = 0;
    let frame = 0;
    const setActive = (index) => { active = Math.max(0, Math.min(index, cards.length - 1)); activateDots(dots, active); };
    const goTo = (index) => {
      const target = Math.max(0, Math.min(index, cards.length - 1));
      track.scrollTo({ left: cards[target].offsetLeft, behavior: 'smooth' });
      setActive(target);
    };
    const bindArrow = (button, delta) => button?.addEventListener('click', (event) => {
      if (stopExisting) event.stopImmediatePropagation();
      goTo(active + delta);
    }, stopExisting);
    bindArrow(prev, -1);
    bindArrow(next, 1);
    dots.forEach((dot, index) => dot.addEventListener('click', () => goTo(index)));
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const left = track.getBoundingClientRect().left;
        const closest = cards.reduce((best, card, index) => {
          const distance = Math.abs(card.getBoundingClientRect().left - left);
          return distance < best.distance ? { index, distance } : best;
        }, { index: 0, distance: Infinity });
        setActive(closest.index);
      });
    }, { passive: true });
    setActive(0);
  };

  const initHomeMobileComponents = (root = document) => {
    root.querySelectorAll('[data-home-attractions-carousel]').forEach((carousel) => bindSnapCarousel(carousel, '[data-home-attractions-track]', '[data-home-attraction-card]', '[data-home-attractions-dot]', '[data-home-attractions-prev]', '[data-home-attractions-next]'));
    root.querySelectorAll('[data-home-rooms-carousel]').forEach((carousel) => bindSnapCarousel(carousel, '[data-home-rooms-track]', '[data-home-room-card]', '[data-home-room-dot]', '.rooms-carousel__button--previous', '.rooms-carousel__button--next', true));

    root.querySelectorAll('[data-home-business-accordion]').forEach((accordion) => {
      if (accordion.dataset.pmwBusinessAccordion === 'true') return;
      accordion.dataset.pmwBusinessAccordion = 'true';
      const items = [...accordion.querySelectorAll('[data-home-business-item]')];
      const openItem = (selected) => items.forEach((item) => {
        const open = item === selected;
        item.classList.toggle('is-open', open);
        item.querySelector('.content-card__accordion-toggle')?.setAttribute('aria-expanded', String(open));
        item.querySelector('.content-card__visual')?.setAttribute('aria-hidden', String(!open));
      });
      items.forEach((item) => item.querySelector('.content-card__accordion-toggle')?.addEventListener('click', () => openItem(item)));
      openItem(items.find((item) => item.classList.contains('is-open')) || items[0]);
    });

    root.querySelectorAll('.reviews').forEach((reviews) => {
      if (reviews.dataset.pmwReviewArrows === 'true') return;
      reviews.dataset.pmwReviewArrows = 'true';
      const dots = [...reviews.querySelectorAll('.review-controls button')];
      const move = (delta) => {
        const current = Math.max(0, dots.findIndex((dot) => dot.classList.contains('is-active')));
        dots[(current + delta + dots.length) % dots.length]?.click();
      };
      reviews.querySelector('[data-home-review-prev]')?.addEventListener('click', () => move(-1));
      reviews.querySelector('[data-home-review-next]')?.addEventListener('click', () => move(1));
    });

    root.querySelectorAll('[data-home-footer-accordion]').forEach((group) => {
      if (group.dataset.pmwFooterAccordion === 'true') return;
      group.dataset.pmwFooterAccordion = 'true';
      group.querySelector('.footer__nav-toggle')?.addEventListener('click', () => {
        const open = !group.classList.contains('is-open');
        group.closest('.footer__main')?.querySelectorAll('[data-home-footer-accordion].is-open').forEach((other) => {
          if (other === group) return;
          other.classList.remove('is-open');
          other.querySelector('.footer__nav-toggle')?.setAttribute('aria-expanded', 'false');
        });
        group.classList.toggle('is-open', open);
        group.querySelector('.footer__nav-toggle')?.setAttribute('aria-expanded', String(open));
      });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initHomeMobileComponents());
  else initHomeMobileComponents();
  document.addEventListener('shopify:section:load', (event) => initHomeMobileComponents(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const item = event.target.closest?.('[data-home-business-item]');
    item?.querySelector('.content-card__accordion-toggle')?.click();
  });
})();
/* PMW homepage wedding gallery carousel 2026-09 */
(() => {
  const initWeddingGalleries = (root = document) => {
    root.querySelectorAll('[data-home-wedding-carousel]').forEach((carousel) => {
      if (carousel.dataset.pmwWeddingCarousel === 'true') return;
      carousel.dataset.pmwWeddingCarousel = 'true';
      const track = carousel.querySelector('[data-home-wedding-track]');
      const cards = [...carousel.querySelectorAll('[data-home-wedding-card]')];
      const dots = [...carousel.querySelectorAll('[data-home-wedding-dot]')];
      if (!track || cards.length < 2) return;
      let active = 0;
      let frame = 0;
      const setActive = (index) => {
        active = Math.max(0, Math.min(index, cards.length - 1));
        dots.forEach((dot, dotIndex) => {
          const selected = dotIndex === active;
          dot.classList.toggle('is-active', selected);
          dot.setAttribute('aria-pressed', String(selected));
        });
      };
      const goTo = (index) => {
        const target = Math.max(0, Math.min(index, cards.length - 1));
        track.scrollTo({ left: cards[target].offsetLeft, behavior: 'smooth' });
        setActive(target);
      };
      carousel.querySelector('[data-home-wedding-prev]')?.addEventListener('click', () => goTo(active - 1));
      carousel.querySelector('[data-home-wedding-next]')?.addEventListener('click', () => goTo(active + 1));
      dots.forEach((dot, index) => dot.addEventListener('click', () => goTo(index)));
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          const left = track.getBoundingClientRect().left;
          const closest = cards.reduce((best, card, index) => {
            const distance = Math.abs(card.getBoundingClientRect().left - left);
            return distance < best.distance ? { index, distance } : best;
          }, { index: 0, distance: Infinity });
          setActive(closest.index);
        });
      }, { passive: true });
      setActive(0);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initWeddingGalleries());
  else initWeddingGalleries();
  document.addEventListener('shopify:section:load', (event) => initWeddingGalleries(event.target));
})();
/* PMW restaurant carousels and mobile accordion 2026-09 */
(() => {
  const bindCarousel = (carousel, selectors) => {
    if (!carousel || carousel.dataset.restaurantCarouselReady === 'true') return;
    carousel.dataset.restaurantCarouselReady = 'true';
    const track = carousel.querySelector(selectors.track);
    const cards = [...carousel.querySelectorAll(selectors.card)];
    const dots = [...carousel.querySelectorAll(selectors.dot)];
    if (!track || cards.length < 2) return;
    let active = 0;
    let frame = 0;
    const setActive = (index) => {
      active = Math.max(0, Math.min(index, cards.length - 1));
      dots.forEach((dot, dotIndex) => {
        const selected = dotIndex === active;
        dot.classList.toggle('is-active', selected);
        dot.setAttribute('aria-pressed', String(selected));
      });
    };
    const goTo = (index) => {
      const target = Math.max(0, Math.min(index, cards.length - 1));
      track.scrollTo({ left: cards[target].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      setActive(target);
    };
    carousel.querySelector(selectors.prev)?.addEventListener('click', () => goTo(active - 1));
    carousel.querySelector(selectors.next)?.addEventListener('click', () => goTo(active + 1));
    dots.forEach((dot, index) => dot.addEventListener('click', () => goTo(index)));
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const left = track.getBoundingClientRect().left;
        const closest = cards.reduce((best, card, index) => {
          const distance = Math.abs(card.getBoundingClientRect().left - left);
          return distance < best.distance ? { index, distance } : best;
        }, { index: 0, distance: Infinity });
        setActive(closest.index);
      });
    }, { passive: true });
    setActive(0);
  };

  const initRestaurantComponents = (root = document) => {
    root.querySelectorAll('[data-restaurant-story-carousel]').forEach((carousel) => bindCarousel(carousel, {
      track: '[data-restaurant-story-track]', card: '[data-restaurant-story-card]', dot: '[data-restaurant-story-dot]', prev: '[data-restaurant-story-prev]', next: '[data-restaurant-story-next]'
    }));
    root.querySelectorAll('[data-restaurant-team-carousel]').forEach((carousel) => bindCarousel(carousel, {
      track: '[data-restaurant-team-track]', card: '[data-restaurant-team-card]', dot: '[data-restaurant-team-dot]', prev: '[data-restaurant-team-prev]', next: '[data-restaurant-team-next]'
    }));
    root.querySelectorAll('[data-restaurant-occasions]').forEach((accordion) => {
      if (accordion.dataset.restaurantAccordionReady === 'true') return;
      accordion.dataset.restaurantAccordionReady = 'true';
      const items = [...accordion.querySelectorAll('[data-restaurant-occasion]')];
      const openItem = (selected) => items.forEach((item) => {
        const open = item === selected;
        item.classList.toggle('is-open', open);
        const toggle = item.querySelector('.restaurant-occasions__toggle');
        toggle?.setAttribute('aria-expanded', String(open));
        const icon = toggle?.querySelector('i');
        if (icon) icon.textContent = open ? '−' : '+';
      });
      items.forEach((item) => item.querySelector('.restaurant-occasions__toggle')?.addEventListener('click', () => openItem(item)));
      openItem(items.find((item) => item.classList.contains('is-open')) || items[0]);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initRestaurantComponents());
  else initRestaurantComponents();
  document.addEventListener('shopify:section:load', (event) => initRestaurantComponents(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    event.target.closest?.('[data-restaurant-occasion]')?.querySelector('.restaurant-occasions__toggle')?.click();
    const teamCard = event.target.closest?.('[data-restaurant-team-card]');
    teamCard?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    const storyCard = event.target.closest?.('[data-restaurant-story-card]');
    storyCard?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  });
})();
/* PMW restaurant feature and review carousels 2026-09 */
(() => {
  const bind = (carousel, selectors) => {
    if (!carousel || carousel.dataset.restaurantSmallCarouselReady === 'true') return;
    carousel.dataset.restaurantSmallCarouselReady = 'true';
    const track = carousel.querySelector(selectors.track);
    const cards = [...carousel.querySelectorAll(selectors.card)];
    const dots = [...carousel.querySelectorAll(selectors.dot)];
    if (!track || cards.length < 2) return;
    let active = 0;
    let frame = 0;
    const select = (index) => {
      active = Math.max(0, Math.min(index, cards.length - 1));
      dots.forEach((dot, i) => {
        const current = i === active;
        dot.classList.toggle('is-active', current);
        dot.setAttribute('aria-pressed', String(current));
      });
    };
    const move = (index) => {
      const target = Math.max(0, Math.min(index, cards.length - 1));
      track.scrollTo({ left: cards[target].offsetLeft - cards[0].offsetLeft, behavior: 'smooth' });
      select(target);
    };
    carousel.querySelector(selectors.prev)?.addEventListener('click', () => move(active - 1));
    carousel.querySelector(selectors.next)?.addEventListener('click', () => move(active + 1));
    dots.forEach((dot, index) => dot.addEventListener('click', () => move(index)));
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const left = track.getBoundingClientRect().left;
        const closest = cards.reduce((best, card, index) => {
          const distance = Math.abs(card.getBoundingClientRect().left - left);
          return distance < best.distance ? { index, distance } : best;
        }, { index: 0, distance: Infinity });
        select(closest.index);
      });
    }, { passive: true });
    select(0);
  };
  const init = (root = document) => {
    root.querySelectorAll('[data-restaurant-features-carousel]').forEach((carousel) => bind(carousel, { track: '[data-restaurant-features-track]', card: '[data-restaurant-feature-card]', dot: '[data-restaurant-features-dot]', prev: '[data-restaurant-features-prev]', next: '[data-restaurant-features-next]' }));
    root.querySelectorAll('[data-restaurant-reviews-carousel]').forEach((carousel) => bind(carousel, { track: '[data-restaurant-reviews-track]', card: '[data-restaurant-review-card]', dot: '[data-restaurant-reviews-dot]', prev: '[data-restaurant-reviews-prev]', next: '[data-restaurant-reviews-next]' }));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
/* PMW wedding mobile carousel controls 2026-09 */
(() => {
  const bind = (root, selectors) => {
    if (!root || root.dataset.weddingCarouselReady === 'true') return;
    root.dataset.weddingCarouselReady = 'true';
    const track = root.querySelector(selectors.track);
    const cards = [...root.querySelectorAll(selectors.card)];
    const dots = [...root.querySelectorAll(selectors.dot)];
    if (!track || cards.length < 2) return;
    let frame = 0;
    const cardPosition = (card) => card.offsetLeft - cards[0].offsetLeft;
    const maxScroll = () => Math.max(0, track.scrollWidth - track.clientWidth);
    const selectFromScroll = () => {
      const left = track.scrollLeft;
      const max = maxScroll();
      const closest = cards.reduce((best, card, index) => {
        const distance = Math.abs(Math.min(cardPosition(card), max) - left);
        return distance < best.distance ? { index, distance } : best;
      }, { index: 0, distance: Infinity });
      dots.forEach((dot, index) => {
        const current = index === closest.index;
        dot.classList.toggle('is-active', current);
        dot.setAttribute('aria-pressed', String(current));
      });
    };
    const goToCard = (index) => {
      const target = ((index % cards.length) + cards.length) % cards.length;
      track.scrollTo({ left: Math.min(cardPosition(cards[target]), maxScroll()), behavior: 'smooth' });
    };
    const stepBy = (direction) => {
      const max = maxScroll();
      const step = Math.max(1, cardPosition(cards[1]));
      const current = track.scrollLeft;
      const target = direction > 0
        ? (current >= max - 3 ? 0 : Math.min(max, current + step))
        : (current <= 3 ? max : Math.max(0, current - step));
      track.scrollTo({ left: target, behavior: 'smooth' });
    };
    root.querySelector(selectors.prev)?.addEventListener('click', () => stepBy(-1));
    root.querySelector(selectors.next)?.addEventListener('click', () => stepBy(1));
    dots.forEach((dot, index) => dot.addEventListener('click', () => goToCard(index)));
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(selectFromScroll);
    }, { passive: true });
    selectFromScroll();
  };
  const init = (scope = document) => {
    scope.querySelectorAll('[data-wedding-values-carousel]').forEach((root) => bind(root,{track:'[data-wedding-values-track]',card:'[data-wedding-value-card]',dot:'[data-wedding-values-dot]',prev:'[data-wedding-values-prev]',next:'[data-wedding-values-next]'}));
    scope.querySelectorAll('[data-wedding-types-carousel]').forEach((root) => bind(root,{track:'[data-wedding-types-track]',card:'[data-wedding-type-card]',dot:'[data-wedding-types-dot]',prev:'[data-wedding-types-prev]',next:'[data-wedding-types-next]'}));
    scope.querySelectorAll('[data-wedding-stories-carousel]').forEach((root) => bind(root,{track:'[data-wedding-stories-track]',card:'[data-wedding-story-card]',dot:'[data-wedding-stories-dot]',prev:'[data-wedding-stories-prev]',next:'[data-wedding-stories-next]'}));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
/* PMW business mobile accordion and timeline controls 2026-09-03 */
(() => {
  const setEventItem = (accordion, selected, open) => {
    accordion.querySelectorAll('[data-business-event-item]').forEach((item) => {
      const active = item === selected && open;
      item.classList.toggle('is-open', active);
      const toggle = item.querySelector('.business-event-types__toggle');
      toggle?.setAttribute('aria-expanded', String(active));
      const icon = toggle?.querySelector('i');
      if (icon) icon.innerHTML = active ? '&minus;' : '+';
    });
  };

  const initBusinessMobile = (root = document) => {
    root.querySelectorAll('[data-business-event-accordion]').forEach((accordion) => {
      if (accordion.dataset.businessAccordionReady === 'true') return;
      accordion.dataset.businessAccordionReady = 'true';
      accordion.querySelectorAll('[data-business-event-item]').forEach((item) => {
        item.querySelector('.business-event-types__toggle')?.addEventListener('click', () => {
          setEventItem(accordion, item, !item.classList.contains('is-open'));
        });
      });
    });

    root.querySelectorAll('[data-business-timeline-carousel]').forEach((carousel) => {
      if (carousel.dataset.businessMobileCarouselReady === 'true') return;
      carousel.dataset.businessMobileCarouselReady = 'true';
      const track = carousel.querySelector('[data-business-timeline]');
      const cards = [...carousel.querySelectorAll('[data-business-timeline-item]')];
      const dots = [...carousel.querySelectorAll('[data-business-timeline-dot]')];
      if (!track || cards.length < 2) return;
      let active = 0;
      let frame = 0;
      const setActive = (index) => {
        active = ((index % cards.length) + cards.length) % cards.length;
        dots.forEach((dot, dotIndex) => {
          const selected = dotIndex === active;
          dot.classList.toggle('is-active', selected);
          dot.setAttribute('aria-pressed', String(selected));
        });
      };
      const goTo = (index) => {
        const target = ((index % cards.length) + cards.length) % cards.length;
        track.scrollTo({ left: cards[target].offsetLeft - cards[0].offsetLeft, behavior: 'smooth' });
        setActive(target);
      };
      carousel.querySelector('[data-business-timeline-prev]')?.addEventListener('click', () => goTo(active - 1));
      carousel.querySelector('[data-business-timeline-next]')?.addEventListener('click', () => goTo(active + 1));
      dots.forEach((dot, index) => dot.addEventListener('click', () => goTo(index)));
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          const origin = cards[0].offsetLeft;
          const closest = cards.reduce((best, card, index) => {
            const distance = Math.abs((card.offsetLeft - origin) - track.scrollLeft);
            return distance < best.distance ? { index, distance } : best;
          }, { index: 0, distance: Infinity });
          setActive(closest.index);
        });
      }, { passive: true });
      setActive(0);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initBusinessMobile());
  else initBusinessMobile();
  document.addEventListener('shopify:section:load', (event) => initBusinessMobile(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const item = event.target.closest?.('[data-business-event-item]');
    const accordion = item?.closest('[data-business-event-accordion]');
    if (item && accordion) setEventItem(accordion, item, true);
  });
})();
/* PMW business venue mobile carousel 2026-09-03 */
(() => {
  const initBusinessVenueCarousels = (root = document) => {
    root.querySelectorAll('[data-business-venue-map]').forEach((map) => {
      if (map.dataset.businessVenueCarouselReady === 'true') return;
      map.dataset.businessVenueCarouselReady = 'true';
      const track = map.querySelector('[data-business-venue-grid]');
      const controls = map.querySelector('[data-business-venue-controls]');
      const dotsRoot = map.querySelector('[data-business-venue-dots]');
      const previous = map.querySelector('[data-business-venue-prev]');
      const next = map.querySelector('[data-business-venue-next]');
      if (!track || !controls || !dotsRoot) return;
      let cards = [];
      let dots = [];
      let active = 0;
      let frame = 0;
      const setActive = (index) => {
        if (!cards.length) return;
        active = ((index % cards.length) + cards.length) % cards.length;
        dots.forEach((dot, dotIndex) => {
          const selected = dotIndex === active;
          dot.classList.toggle('is-active', selected);
          dot.setAttribute('aria-pressed', String(selected));
        });
      };
      const goTo = (index) => {
        if (!cards.length) return;
        const target = ((index % cards.length) + cards.length) % cards.length;
        track.scrollTo({ left: cards[target].offsetLeft - cards[0].offsetLeft, behavior: 'smooth' });
        setActive(target);
      };
      const refresh = () => {
        cards = [...track.querySelectorAll('[data-business-venue-card]:not([hidden])')];
        active = 0;
        dotsRoot.replaceChildren();
        dots = cards.map((card, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.setAttribute('aria-label', `Pokaż salę ${index + 1}`);
          dot.addEventListener('click', () => goTo(index));
          dotsRoot.append(dot);
          return dot;
        });
        controls.hidden = cards.length < 2;
        track.scrollTo({ left: 0, behavior: 'auto' });
        if (cards.length) setActive(0);
      };
      previous?.addEventListener('click', () => goTo(active - 1));
      next?.addEventListener('click', () => goTo(active + 1));
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          if (!cards.length) return;
          const origin = cards[0].offsetLeft;
          const closest = cards.reduce((best, card, index) => {
            const distance = Math.abs((card.offsetLeft - origin) - track.scrollLeft);
            return distance < best.distance ? { index, distance } : best;
          }, { index: 0, distance: Infinity });
          setActive(closest.index);
        });
      }, { passive: true });
      map.querySelectorAll('[data-business-map-tab]').forEach((tab) => tab.addEventListener('click', () => requestAnimationFrame(refresh)));
      refresh();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initBusinessVenueCarousels());
  else initBusinessVenueCarousels();
  document.addEventListener('shopify:section:load', (event) => initBusinessVenueCarousels(event.target));
})();
/* PMW business testimonials mobile carousel 2026-09-03 */
(() => {
  const initBusinessTestimonials = (root = document) => {
    root.querySelectorAll('[data-business-testimonials-carousel]').forEach((carousel) => {
      if (carousel.dataset.businessTestimonialsReady === 'true') return;
      carousel.dataset.businessTestimonialsReady = 'true';
      const track = carousel.querySelector('[data-business-testimonials-track]');
      const cards = [...carousel.querySelectorAll('[data-business-testimonial-card]')];
      const dots = [...carousel.querySelectorAll('[data-business-testimonials-dot]')];
      if (!track || cards.length < 2) return;
      let active = 0;
      let frame = 0;
      const setActive = (index) => {
        active = ((index % cards.length) + cards.length) % cards.length;
        dots.forEach((dot, dotIndex) => {
          const selected = dotIndex === active;
          dot.classList.toggle('is-active', selected);
          dot.setAttribute('aria-pressed', String(selected));
        });
      };
      const goTo = (index) => {
        const target = ((index % cards.length) + cards.length) % cards.length;
        track.scrollTo({ left: cards[target].offsetLeft - cards[0].offsetLeft, behavior: 'smooth' });
        setActive(target);
      };
      carousel.querySelector('[data-business-testimonials-prev]')?.addEventListener('click', () => goTo(active - 1));
      carousel.querySelector('[data-business-testimonials-next]')?.addEventListener('click', () => goTo(active + 1));
      dots.forEach((dot, index) => dot.addEventListener('click', () => goTo(index)));
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          const origin = cards[0].offsetLeft;
          const closest = cards.reduce((best, card, index) => {
            const distance = Math.abs((card.offsetLeft - origin) - track.scrollLeft);
            return distance < best.distance ? { index, distance } : best;
          }, { index: 0, distance: Infinity });
          setActive(closest.index);
        });
      }, { passive: true });
      setActive(0);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initBusinessTestimonials());
  else initBusinessTestimonials();
  document.addEventListener('shopify:section:load', (event) => initBusinessTestimonials(event.target));
})();
/* PMW business desktop event carousel 2026-09-03 */
(() => {
  const initBusinessEventCarousels = (root = document) => {
    root.querySelectorAll('[data-business-event-carousel]').forEach((carousel) => {
      if (carousel.dataset.businessEventCarouselReady === 'true') return;
      carousel.dataset.businessEventCarouselReady = 'true';
      const track = carousel.querySelector('[data-business-event-track]');
      const cards = [...carousel.querySelectorAll('[data-business-event-item]')];
      if (!track || cards.length < 2) return;
      const maxScroll = () => Math.max(0, track.scrollWidth - track.clientWidth);
      const cardStep = () => cards[1] ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth;
      const move = (direction) => {
        const max = maxScroll();
        const current = track.scrollLeft;
        const step = Math.max(1, cardStep());
        const target = direction > 0
          ? (current >= max - 3 ? 0 : Math.min(max, current + step))
          : (current <= 3 ? max : Math.max(0, current - step));
        track.scrollTo({ left: target, behavior: 'smooth' });
      };
      carousel.querySelector('[data-business-event-prev]')?.addEventListener('click', () => move(-1));
      carousel.querySelector('[data-business-event-next]')?.addEventListener('click', () => move(1));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initBusinessEventCarousels());
  else initBusinessEventCarousels();
  document.addEventListener('shopify:section:load', (event) => initBusinessEventCarousels(event.target));
})();
/* PMW SPA packages mobile carousel 2026-09-03 */
(() => {
  const initSpaPackageCarousels = (root = document) => {
    root.querySelectorAll('[data-spa-packages-carousel]').forEach((carousel) => {
      if (carousel.dataset.spaPackagesCarouselReady === 'true') return;
      carousel.dataset.spaPackagesCarouselReady = 'true';
      const track = carousel.querySelector('[data-spa-packages-track]');
      const cards = [...carousel.querySelectorAll('[data-spa-package-card]')];
      const dots = [...carousel.querySelectorAll('[data-spa-packages-dot]')];
      if (!track || cards.length < 2) return;
      let active = 0;
      let frame = 0;
      const setActive = (index) => {
        active = ((index % cards.length) + cards.length) % cards.length;
        dots.forEach((dot, dotIndex) => {
          const selected = dotIndex === active;
          dot.classList.toggle('is-active', selected);
          dot.setAttribute('aria-pressed', String(selected));
        });
      };
      const goTo = (index) => {
        const target = ((index % cards.length) + cards.length) % cards.length;
        track.scrollTo({ left: cards[target].offsetLeft - cards[0].offsetLeft, behavior: 'smooth' });
        setActive(target);
      };
      carousel.querySelector('[data-spa-packages-prev]')?.addEventListener('click', () => goTo(active - 1));
      carousel.querySelector('[data-spa-packages-next]')?.addEventListener('click', () => goTo(active + 1));
      dots.forEach((dot, index) => dot.addEventListener('click', () => goTo(index)));
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          const origin = cards[0].offsetLeft;
          const closest = cards.reduce((best, card, index) => {
            const distance = Math.abs((card.offsetLeft - origin) - track.scrollLeft);
            return distance < best.distance ? { index, distance } : best;
          }, { index: 0, distance: Infinity });
          setActive(closest.index);
        });
      }, { passive: true });
      setActive(0);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initSpaPackageCarousels());
  else initSpaPackageCarousels();
  document.addEventListener('shopify:section:load', (event) => initSpaPackageCarousels(event.target));
})();
/* PMW history counters and scroll-synced timeline 2026-09-04 */
(() => {
  const initHistoryInteractions = (scope = document) => {
    scope.querySelectorAll('[data-history-counter]').forEach((counter) => {
      if (counter.dataset.historyCounterReady === 'true') return;
      counter.dataset.historyCounterReady = 'true';
      const target = Number(counter.dataset.historyCounter);
      if (!Number.isFinite(target)) return;
      const finalText = new Intl.NumberFormat('pl-PL').format(target);
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const animate = () => {
        if (reducedMotion) {
          counter.textContent = finalText;
          return;
        }
        const start = performance.now();
        const duration = 1500;
        counter.textContent = '0';
        const frame = (now) => {
          const progress = Math.min((now - start) / duration, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          counter.textContent = progress === 1 ? finalText : new Intl.NumberFormat('pl-PL').format(Math.round(target * eased));
          if (progress < 1) requestAnimationFrame(frame);
        };
        requestAnimationFrame(frame);
      };
      if (!('IntersectionObserver' in window)) {
        animate();
        return;
      }
      const observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        animate();
      }, { threshold: 0.2 });
      observer.observe(counter);
    });

    scope.querySelectorAll('.history-chronicle').forEach((chronicle) => {
      if (chronicle.dataset.historyScrollReady === 'true') return;
      const buttons = [...chronicle.querySelectorAll('.history-chronicle__nav button')];
      const chapters = [...chronicle.querySelectorAll('[data-history-chapter]')];
      if (!buttons.length || buttons.length !== chapters.length) return;
      chronicle.dataset.historyScrollReady = 'true';
      let active = -1;
      let scheduled = false;
      const setActive = (index) => {
        if (index === active || index < 0 || index >= buttons.length) return;
        active = index;
        buttons.forEach((button, buttonIndex) => {
          const selected = buttonIndex === index;
          button.classList.toggle('is-active', selected);
          if (selected) button.setAttribute('aria-current', 'step');
          else button.removeAttribute('aria-current');
        });
        if (window.matchMedia('(max-width: 960px)').matches) {
          const nav = buttons[index].parentElement;
          const targetLeft = buttons[index].offsetLeft - ((nav.clientWidth - buttons[index].offsetWidth) / 2);
          nav.scrollTo({ left: Math.max(0, targetLeft), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        }
      };
      const update = () => {
        scheduled = false;
        const chronicleRect = chronicle.getBoundingClientRect();
        if (chronicleRect.bottom <= 0 || chronicleRect.top >= window.innerHeight) return;
        const marker = window.innerHeight * 0.46;
        let next = 0;
        chapters.forEach((chapter, index) => {
          if (chapter.getBoundingClientRect().top <= marker) next = index;
        });
        setActive(next);
      };
      const scheduleUpdate = () => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(update);
      };
      window.addEventListener('scroll', scheduleUpdate, { passive: true });
      window.addEventListener('resize', scheduleUpdate, { passive: true });
      buttons.forEach((button, index) => button.addEventListener('click', () => {
        setActive(index);
        chapters[index].scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      }));
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initHistoryInteractions());
  else initHistoryInteractions();
  document.addEventListener('shopify:section:load', (event) => initHistoryInteractions(event.target));
})();
/* PMW events calendar 2026-09-04 */
(() => {
  const initEventsCalendars = (root = document) => {
    root.querySelectorAll('[data-events-calendar]').forEach((calendar) => {
      if (calendar.dataset.eventsCalendarReady === 'true') return;
      calendar.dataset.eventsCalendarReady = 'true';
      const buttons = [...calendar.querySelectorAll('[data-event-day]')];
      const day = calendar.querySelector('[data-events-selection-day]');
      const title = calendar.querySelector('[data-events-selection-title]');
      const link = calendar.querySelector('[data-events-selection-link]');
      const activate = (button) => {
        if (!button) return;
        buttons.forEach((item) => item.classList.toggle('is-active', item === button));
        if (day) day.textContent = button.dataset.eventDay || '';
        if (title) title.textContent = button.dataset.eventTitle || '';
        if (link) {
          link.href = button.dataset.eventLink || '/pages/kontakt';
          link.firstChild.textContent = `${button.dataset.eventLinkLabel || 'Sprawdź szczegóły'} `;
        }
      };
      buttons.forEach((button) => button.addEventListener('click', () => activate(button)));
      activate(buttons[0]);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initEventsCalendars());
  else initEventsCalendars();
  document.addEventListener('shopify:section:load', (event) => initEventsCalendars(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const button = event.target.closest?.('[data-event-day]');
    button?.click();
  });
})();
/* Keep editable image overlays anchored after full page loads and Theme Editor section reloads. */
(function () {
  function mountPmwMediaOverlays(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.pmw-media-overlay').forEach(function (overlay) {
      if (overlay.parentElement) overlay.parentElement.classList.add('pmw-has-media-overlay');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { mountPmwMediaOverlays(document); });
  } else {
    mountPmwMediaOverlays(document);
  }
  document.addEventListener('shopify:section:load', function (event) { mountPmwMediaOverlays(event.target); });
  document.addEventListener('shopify:block:select', function (event) { mountPmwMediaOverlays(event.target); });
})();